/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-unused-expressions */
import { KeyboardEvent, useCallback } from "react";
import { Controller, useForm } from "react-hook-form";
import * as MUI from "@mui/material";
import * as MUIcons from "@mui/icons-material";

import { civilStoreCPF } from "../../../hooks/store";
import { useAuth } from "../../../hooks/auth";

import { LayoutConsultaCivil } from "./LayoutConsultaCivil";
import { ResultadoConsultaCivil } from "../../../components";

type InputProps = {
  cpf: string;
};

export const FiltroCivilCPF: React.FC = () => {
  const { control, handleSubmit } = useForm<InputProps>({
    defaultValues: {
      cpf: "",
    },
  });

  const { user } = useAuth();
  const { url: urlCivil } = user!.sistemas.filter((s) => {
    return s.id_sistema === 2 ? s.url : false;
  })[0];

  const {
    consultaCivilCPF,
    resultadoCivilCPF,
    mensagemCivil,
    limparConsultaCivilCPF: limparConsultaCivil,
  } = civilStoreCPF((state) => state.civil);
  const { loading } = civilStoreCPF((state) => state.global);

  const pesquisaCivilCPF = (data: InputProps) => {
    consultaCivilCPF(urlCivil, data.cpf);
  };

  const keyBoardClick = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    e.key === "Enter";
  }, []);

  return (
    <LayoutConsultaCivil>
      <MUI.Grid
        component="form"
        alignItems="center"
        width={["100%", "100%", "100%", "80%", "60%"]}
        container
        spacing={1}
        onSubmit={handleSubmit(pesquisaCivilCPF)}
      >
        <MUI.Grid item xs={12} md={4} sm={4}>
          <Controller
            name="cpf"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MUI.TextField
                label="Informe o CPF"
                value={value.replace(/\D/g, "")}
                onChange={onChange}
                onKeyPress={keyBoardClick}
                fullWidth
                size="small"
                disabled={loading}
              />
            )}
          />
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={loading}
            startIcon={<MUIcons.Search />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Consultar
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>

        <MUI.Grid item xs={12} md={3} sm={3}>
          <MUI.Button
            fullWidth
            variant="outlined"
            color="secondary"
            onClick={limparConsultaCivil}
            disabled={loading}
            startIcon={<MUIcons.Clear />}
          >
            <MUI.Typography
              variant="button"
              whiteSpace="nowrap"
              textOverflow="ellipsis"
              overflow="hidden"
            >
              Limpar resultado
            </MUI.Typography>
          </MUI.Button>
        </MUI.Grid>
      </MUI.Grid>

      <MUI.Stack>
        {resultadoCivilCPF || mensagemCivil ? (
          <MUI.Typography variant="h6">Resultado da consulta:</MUI.Typography>
        ) : (
          false
        )}

        {!loading ? (
          (resultadoCivilCPF &&
            resultadoCivilCPF?.map((cidadao) => (
              <ResultadoConsultaCivil
                key={cidadao.NumeroPedido}
                infoName={cidadao.Nome}
                infoMae={cidadao.Mae}
                infoPai={cidadao.Pai}
                to={`consulta-civil/ficha-civil/${cidadao.NumeroPessoa}`}
              />
            ))) || <MUI.Typography variant="h6">{mensagemCivil}</MUI.Typography>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </LayoutConsultaCivil>
  );
};
